/*
 *
 * Navigation constants
 *
 */

export const TOGGLE_MENU = "src/Navigation/TOGGLE_MENU";
export const TOGGLE_FILTER = "src/Navigation/TOGGLE_FILTER";

export const TOGGLE_CART = "src/Navigation/TOGGLE_CART";
export const TOGGLE_BRAND = "src/Navigation/TOGGLE_BRAND";
export const SEARCH_CHANGE = "src/Navigation/SEARCH_CHANGE";
export const SUGGESTIONS_FETCH_REQUEST =
  "src/Navigation/SUGGESTIONS_FETCH_REQUEST";
export const SUGGESTIONS_CLEAR_REQUEST =
  "src/Navigation/SUGGESTIONS_CLEAR_REQUEST";
